/**
 * ChannelDTO entity class
 */

/**
 * ChannelDTOFactory
 * returns ChannelDTO entity class
 *
 * @class ChannelDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ChannelDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ChannelDTOFactory
 */
/* @ngInject */
export default function ChannelDTOFactory ($http, Channel, Type, UrlPolicy, m2mMixin, authSvc, alertLiteSvc) {
  /* === ChannelDTO class === */

  /**
   * ChannelDTO model
   *
   * @class ChannelDTO
   * @classdesc ChannelDTO model
   * @memberof models
   * @see models
   * @extends models.Channel
   * @mixes models.m2mMixin
   * @return {models.ChannelDTO} ChannelDTO entity
   */
  function ChannelDTO () {
    var obj = Channel.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ChannelDTO.prototype = Object.create(Channel.prototype)
  ChannelDTO.prototype.constructor = ChannelDTO

  /* === ChannelDTO instance methods & fields === */

  Object.assign(ChannelDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ChannelDTO#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      $ageRatingType: 'default',
      $country: {
        id: Number,
        name: String,
        isoCode: String
      },
      $defaultAgeRating: {
        id: Number,
        country: {
          id: Number,
          name: String,
          isoCode: String
        },
        sortOrder: Number,
        rating: String
      },
      ageRating: {
        id: Number,
        country: {
          id: Number,
          name: String,
          isoCode: String
        },
        sortOrder: Number,
        rating: String
      },
      catchupAllowed: Boolean,
      channelNumber: Number,
      channelType: String,
      enabled: Boolean,
      chatAllowed: Boolean,
      epgId: Type(String('0')), // TODO empty string should be valid here!,
      language: String,
      locked: Boolean,
      logoUrl: String,
      networks: ['Network'],
      orderType: Type(String('Default')),
      resolution: 'HD',
      dolbyAtmosAvailable: Boolean,
      subscriber: 'Subscriber',
      subscriberIds: [Number],
      timeshiftAllowed: Boolean,
      urls: {
        STB: 'MediaUrlDTO',
        PC: 'MediaUrlDTO',
        iOS: 'MediaUrlDTO',
        Android: 'MediaUrlDTO',
        SamsungTV: 'MediaUrlDTO',
        Others: 'MediaUrlDTO',
        WEB: 'MediaUrlDTO'
      },
      acl: {
        id: Number,
        name: String
      },
      contentSets: ['ChannelSet'],
      defaultStream: 'DefaultStream',
      policedStreams: null, // 'PolicedStreams'
      streamPolicy: 'UrlPolicy',
      streamBindings: ['StreamBinding'],
      assignedSubscriptions: ['Subscription'],
      /* local variables */
      $geoBlockingEnabled: false,
      $itemType: 'channel',
      $contentSetType: 'channelSet',
      $contentSetName: 'Channel Set',
      $contentSetObject: 'channelSets'
    },

    /**
     * Get underlying object
     *
     * @memberof models.ChannelDTO#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      UrlPolicy.prepareToSaveContentItem(this)

      this.acl = this.$geoBlockingEnabled ? this.acl : null

      // delete null urls
      if (this.urls) {
        this.urls =
          Object.keys(this.urls)
            .reduce(
              (o, platform) => {
                if (this.urls[platform] != null) {
                  o[platform] = this.urls[platform]
                }
                return o
              },
              Object.create(null)
            )
      }

      /* content sets */
      // this.channelSets = this.$networksSets.filter(ns => ns.channelSet).map((ns) => {
      //   return { id: ns.channelSet.id }
      // })

      return Channel.prototype._object.apply(this, arguments)
    },

    /**
     * Prepare channel
     *
     * @memberof models.ChannelDTO#
     * @override
     */
    _prepare: function () {
      UrlPolicy.prepareToLoadContentItem(this)

      this.$geoBlockingEnabled = !!this.acl
      if ((!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED')) && this.urls) {
        delete this.urls.WEB
      }

      if (this.ageRating) {
        if (!this.ageRating.country) {
          this.$ageRatingType = 'default'
          this.$defaultAgeRating = this.ageRating
          this.ageRating = {}
        } else {
          this.$ageRatingType = 'countryBased'
          this.$country = this.ageRating.country
          this.$defaultAgeRating = {}
        }
      }
    }

  }, m2mMixin('networks'))

  /* === ChannelDTO static methods & fields === */

  /**
   * Load Content sets
   *
   * @param chnl
   * @returns {*}
   */
  ChannelDTO.loadAvailableContentSets = function (chnl) {
    return $http.get(`/nora/api/channels/${chnl.id}/extra/content-sets`)
      .data()
      .then(data => data.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  // copy all static methods from Channel class
  Object.assign(ChannelDTO, Channel)
  ChannelDTO._name = 'ChannelDTO'
  ChannelDTO._publicName = 'Channel'
  ChannelDTO.init()

  return ChannelDTO
}
